// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"954ea20e","703":"9539698a","787":"00b624d0"}[chunkId] + ".chunk.js";
};